import { useMemo } from 'react';

import { SupportedRegions } from '@rbi-ctg/frontend';
import { IValidationConfig } from 'utils/form/user-profile-validation-config/types';

export const useFieldIsRequired = (
  region: SupportedRegions,
  validationConfig: IValidationConfig,
  fieldName: string
) => {
  const fieldIsRequired = useMemo(() => {
    const required = validationConfig[fieldName].required;

    return typeof required === 'boolean' ? required : required.locales.includes(region);
  }, [region, validationConfig]);

  return fieldIsRequired;
};
